import { useCopyFeedback } from '@/hooks/useCopyFeedback';
import { useEffect } from 'react';

/**
 * Accessibility component for copy feedback
 * Creates and manages ARIA live region for screen readers
 * 
 * This component should be included once in the app layout
 * to ensure proper accessibility support for copy operations
 */
export const CopyFeedbackAria = () => {
  const { createAriaLiveRegion } = useCopyFeedback();

  useEffect(() => {
    // Create ARIA live region when component mounts
    createAriaLiveRegion();
  }, [createAriaLiveRegion]);

  // This component doesn't render anything visible
  // The ARIA live region is added directly to the DOM
  return null;
}; 